module.exports = __webpack_public_path__ + "media/images/illustrations/cash_small-3728010ec35ea7e0f13fa6ce1a77a5a5.svg";